<template>
  <div class="cart-header">
    <button class="btn btn-sm btn-icon" @click="close">
      <span class="ti-arrow-left"></span>
      Назад
    </button>
  </div>
</template>
<script>
export default {
  name: "header",
  methods: {
    close() {
      let query = Object.assign({}, this.$route.query);
      delete query.id;
      delete query.card;
      this.$router.replace({ query });
    },
  },
  components: {},
};
</script>
<style>
</style>
